module.exports = "/img/_/_/_/assets/images/creeper/book/common//20.jpg?fcee63f837a3ab1ca2d11c1b53662a50";